import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DashboardService } from '@shared/components/dashboard-viewer/dashboard.service';
import { Program } from './program.model';

@Injectable({ providedIn: 'root' })
export class ProgramDashboardService {
  constructor(private _dashboardService: DashboardService) {}

  hasProgramDashboards(program: Program): Observable<boolean> {
    const sponsor = program?.sponsor;
    if (!program?.programPermissions?.modulePermissions?.home?.view
      || !sponsor?.id
      || !sponsor.embeddedDashboardEnabled) {
      return of(false);
    }
    return this._dashboardService
      .hasDashboards(sponsor.id, { location: 'program', programId: program.id })
      .pipe(
        catchError((error) => {
          console.warn('Program dashboards discovery failed', program.id, error);
          return of(false);
        }),
      );
  }
}
